import homePage from "./components/homePage";
import adminPage from "./components/adminPage";
import securePage from "./components/securePage";
import test from "./components/test";
import svatba from "./components/svatba";
import chldren from "./components/chldren";
import portrets from "./components/portrets";
import reportaz from "./components/reportaz";
import family from "./components/family";
import theatre from "./components/theatre";


export default [
    { path: '/', component: homePage },
    { path: '/omne', component: homePage},
    { path: '/portfolio', component: homePage},
    { path: '/cenik', component: homePage},
    { path: '/reference', component: homePage},
    { path: '/kontakt', component: homePage},
    { path: '/admin', name: "adminPage", component: adminPage},
    { path: '/test', name: "test", component: test},
    { path: '/svatba', name:"svatba", component: svatba},
    { path: '/miminka', name: "chldren", component: chldren},
    { path: '/portrety', name: "portrets", component: portrets },
    { path: '/reportaz', name: "reportaz", component: reportaz},
    { path: '/rodina', name: "family", component: family},
    { path: '/divadlo', name: "theatre", component: theatre},
    { path: '/admin/secure', name: "securePage", component: securePage },
]